<div class="admin-settings-field-value">
  @if (fieldType !== 'image') {
    <span>
      @if (!editable) {
        <span>
          <strong>
            {{subSetting.name | translate}}:
          </strong>

          @if (displayValue.indexOf('http') !== 0) {
            <span class="admin-settings-field-value__view-text">
              {{displayValue}}
            </span>
          }
          @else {
            <a [href]="displayValue" class="admin-settings-field-value__view-text">
              {{displayValue}}
            </a>
          }
        </span>
      }
      @else {
        <span>
          @if (fieldType !== 'checkbox') {
            <ng-container>
              <mat-form-field appearance="outline" class="admin-settings-field-value__form-field">
                <mat-label>
                  {{subSetting.name | translate}}
                </mat-label>

               @switch (fieldType) {
                 @case ('text') {
                   <label>
                    <input
                      matInput
                      type="text"
                      [(ngModel)]="subSetting.value"
                      (ngModelChange)="valueChanged()"
                    >
                   </label>
                 }

                 @case ('number') {
                   <label>
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="subSetting.value"
                      (ngModelChange)="valueChanged()"
                    >
                   </label>
                 }

                 @case ('select') {
                   <mat-select [(ngModel)]="subSetting.value" (ngModelChange)="valueChanged()">
                     @for (option of options; track $index) {
                       <mat-option [value]="option.value">
                         <span>
                           {{option.viewValue}}
                         </span>
                       </mat-option>
                     }
                   </mat-select>
                 }
               }
              </mat-form-field>
            </ng-container>
          }

          @if (fieldType === 'checkbox') {
            <span>
              <mat-checkbox
                labelPosition="before"
                [(ngModel)]="subSetting.value"
                (ngModelChange)="valueChanged()"
              >
                {{subSetting.name | translate}}:
              </mat-checkbox>
            </span>
          }
        </span>
      }
    </span>
  }

  @if (fieldType === 'image') {
    <span>
      <span>
        <strong>
          {{subSetting.name | translate}}:
        </strong>
      </span>

      @if (editable) {
        <app-edit-field-image-selector
          [field]="imageField"
          [object]="imageObject"
        ></app-edit-field-image-selector>
      }
      @else if (!editable && imageObject[imageField.name].value && imageObject[imageField.name].value !== ('None' || null)) {
        <app-thumbnail
          [item]="imageObject[imageField.name]"
          [imageIdField]="'value'"
          [stylingClass]="'image-uploaded-view'">
        </app-thumbnail>
      }
    </span>
  }
</div>

